import { FormGroup, FormControl } from '@angular/forms';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup, ILoginCredentials } from '@shared-libs/interfaces';

export class LoginFormFactory {
	public static create(): IFormGroup<ILoginCredentials> {
		return new FormGroup({
			username: new FormControl('', [SharedFormValidators.required]),
			password: new FormControl('', [SharedFormValidators.required]),
			keepMeLoggedIn: new FormControl(),
		}) as IFormGroup;
	}

	public static getValue(form: IFormGroup<ILoginCredentials>): ILoginCredentials {
		form.value.username = form.value.username.trim();
		return form.value;
	}
}
